import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { Download, PagedData } from '../models/general.models';
import { AreaTaskGroup, DownloadTaskStatus, Task, TaskGroup } from '../models/tasks.model';
import { UserService } from './user.service';
import { DownloadService } from './download.service';

@Injectable({
  providedIn: 'root'
})
export class TaskService {
  private baseUrl: string = environment.baseUrl;

  constructor(
    private http: HttpClient,
    private userService: UserService,
    private downloadService: DownloadService
  ) {
  }

  public getTasksGroup(pageNumber: number, pageSize: number): Observable<PagedData<TaskGroup>> {
    const endpoint = `${this.baseUrl}/${this.userService.mySlug}/task-groups/?page=${pageNumber}&limit=${pageSize}`;
    return this.http.get<PagedData<TaskGroup>>(endpoint);
  }

  public getTasksGroupById(id: string): Observable<TaskGroup> {
    const endpoint = `${this.baseUrl}/${this.userService.mySlug}/task-groups/${id}/`;
    return this.http.get<TaskGroup>(endpoint);
  }

  public deleteTasksGroupById(id: string): Observable<TaskGroup> {
    const endpoint = `${this.baseUrl}/${this.userService.mySlug}/task-groups/${id}/`;
    return this.http.delete<TaskGroup>(endpoint);
  }
  public prepareDownloadTasksGroupById(id: string): Observable<{task_id: string}> {
    const endpoint = `${this.baseUrl}/${this.userService.mySlug}/task-groups/${id}/prepare-download/`;
    return this.http.get<{task_id: string}>(endpoint);
  }

  public downloadTasksGroupById(id: string, task_id: string, name: string): Observable<Download> {
    const endpoint = `${this.baseUrl}/${this.userService.mySlug}/task-groups/${id}/download/${task_id}/`;
    return this.downloadService.downloadZip(endpoint, `${name}.zip`);
  }

  public prepareDownloadAreaTasksGroupById(areaId: string, id: string): Observable<{task_id: string}> {
    const endpoint = `${this.baseUrl}/${this.userService.mySlug}/task-groups/${id}/area-task-groups/${areaId}/prepare-download/`;
    return this.http.get<{task_id: string}>(endpoint);
  }

  public downloadAreaTasksGroupById(areaId: string, id: string, task_id: string, name: string): Observable<Download> {
    const endpoint = `${this.baseUrl}/${this.userService.mySlug}/task-groups/${id}/area-task-groups/${areaId}/download/${task_id}/`;
    return this.downloadService.downloadZip(endpoint, `${name}.zip`);
  }

  public deleteAreaTasksGroupById(id: string, task_id: string): Observable<DownloadTaskStatus> {
    const endpoint = `${this.baseUrl}/${this.userService.mySlug}/task-groups/${id}/area-task-groups/${task_id}/`;
    return this.http.delete<DownloadTaskStatus>(endpoint);
  }

  public getTasksGroupByIdTasks(pageNumber: number, pageSize: number, id: string): Observable<PagedData<AreaTaskGroup>> {
    const endpoint = `${this.baseUrl}/${this.userService.mySlug}/task-groups/${id}/area-task-groups/?page=${pageNumber}&limit=${pageSize}`;
    return this.http.get<PagedData<AreaTaskGroup>>(endpoint);
  }

  public getTaskStatus(id: string): Observable<Task> {
    const endpoint = `${this.baseUrl}/${this.userService.mySlug}/tasks/status/${id}/`;
    return this.http.get<Task>(endpoint);
  }
}
